import FxPortfolio from './components/FxPortfolio';

const App = () => <FxPortfolio />;

export default App;
